module.exports = __webpack_public_path__ + "static/media/Gokul.706e2516.jpg";